import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=d99c53a8&scoped=true&"
import script from "./RightPanel.vue?vue&type=script&lang=js&"
export * from "./RightPanel.vue?vue&type=script&lang=js&"
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=d99c53a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99c53a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d99c53a8')) {
      api.createRecord('d99c53a8', component.options)
    } else {
      api.reload('d99c53a8', component.options)
    }
    module.hot.accept("./RightPanel.vue?vue&type=template&id=d99c53a8&scoped=true&", function () {
      api.rerender('d99c53a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RightPanel.vue"
export default component.exports